<template>
	<div>
		<CurrentReservation v-dr-permission="'drg.app.reservations.view'" class="mb-6"/>
		<ProfileView v-dr-permission="'drg.app.profile.view'" class="mb-6"/>
		<AddressView  v-dr-permission="'drg.app.profile.address.view'" class="mb-6"/>
		<ConsentsView v-dr-permission="'drg.app.profile.consents.view'" class="mb-6"/>
	</div>
</template>

<script>
import ProfileView from "@/components/profile/ProfileView";
import ConsentsView from "@/components/profile/ConsentsView";
import AddressView from "@/components/profile/AddressView";

export default {
    name: "Profile",
    components: {AddressView, ConsentsView, ProfileView }
};
</script>
<style>
[data-view-type="profile"] .bb-view-background {
	background: var(--profile-background);
}
</style>
